import { Component, OnInit, AfterViewInit } from '@angular/core';
declare var $;

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.css']
})
export class AccessDeniedComponent implements AfterViewInit {

  constructor() { }

  ngAfterViewInit() {
    $('.preloader').fadeOut();
  }
}
